import {IDataClientService} from '../../platform/services/data/DataClientService';
import {IAuthService} from '../../platform/services/auth/AuthService';
import {queryGqlApi} from '../../graphql/queryGqlApi';
import {getClientUsageQuery} from '../../graphql/clientUsage';
import {ClientMeta} from '../../shared/types/SubscriptionTypes';

export type ClientUsage = ClientMeta & {clientId: string};

export async function fetchClientUsage(
    dataClientService: IDataClientService,
    authService: IAuthService,
    clientId: string
): Promise<ClientUsage> {
    return queryGqlApi(
        getClientUsageQuery,
        {clientId},
        dataClientService,
        authService,
        'pgServer'
    );
}
